module.exports = __webpack_public_path__ + "static/media/la.a8b50f89.svg";